import { useAuth } from "@bcc/contexts/auth-context";
import { useTranslation } from "react-i18next";
import { setHomeViewTestId } from "./home-view.utils";

interface HomeViewProps {
  testId?: string;
}

export function HomeView({ testId }: HomeViewProps = {}) {
  const { roaster } = useAuth();
  const { t } = useTranslation();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return t("views.dashboard.greetings.morning");
    if (hour < 18) return t("views.dashboard.greetings.afternoon");
    return t("views.dashboard.greetings.evening");
  };

  return (
    <div
      data-testid={testId ?? setHomeViewTestId("container")}
      className="flex min-h-[calc(100vh-200px)] items-center justify-center"
    >
      <div className="text-center">
        <h1
          data-testid={setHomeViewTestId("greeting")}
          className="text-4xl font-semibold tracking-tight text-balance"
        >
          {getGreeting()},{" "}
          {roaster?.roasterName || t("views.dashboard.defaultPartner")}!
        </h1>
        <p
          data-testid={setHomeViewTestId("welcome-message")}
          className="mt-4 text-lg text-muted-foreground"
        >
          {t("views.home.welcome")}
        </p>
      </div>
    </div>
  );
}
